export default __webpack_public_path__ + "static/media/menu_playbox_sp.11efa6d1.png";